import { z } from 'zod'

export const guideDisplayKey = 'guide_phone_display'
export const guideDisplaySchema = z.object({
  time: z.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/, '请填写有效时间，例如 10:55'),
  battery: z.number().int().min(0).max(100),
  width: z.union([z.literal(393), z.literal(430)]),
}).strict()
export type GuideDisplaySettings = z.infer<typeof guideDisplaySchema>
export const defaultGuideDisplay: GuideDisplaySettings = { time: '10:55', battery: 96, width: 393 }

export function parseGuideDisplay(value?: string): GuideDisplaySettings {
  try {
    const parsed = guideDisplaySchema.safeParse(JSON.parse(value ?? ''))
    return parsed.success ? parsed.data : { ...defaultGuideDisplay }
  } catch { return { ...defaultGuideDisplay } }
}
